<template>
  <div>
     <cooperation-header
      :actIndex="actIndex"
      :imgList="imgList"
      :topStyle="topStyle"
      :logo="logo"
      v-if="joinId == 0"
      :titleObj="titleObj"
    >
    </cooperation-header> 
    <!-- 合作加盟组件 -->
    <cooperation-join
      v-if="joinId == 0"
      @changeJion="changeJion"
    ></cooperation-join>
    <!-- 合作联盟填写组件 -->
    <cooperationFill
      v-if="joinId == 1"
      @setLastPage="setLastPage"
    ></cooperationFill>

    <cooperation-footer v-if="joinId == 0" :bottom="bottom" :bottomInfo="bottomInfo"></cooperation-footer>

  </div>
</template>
<script>
import cooperationHeader from "@/components/mobile/Header";
import cooperationJoin from "@/components/mobile/cooperationJoin";
import cooperationFill from "@/components/mobile/cooperationFill";
import cooperationFooter from "@/components/mobile/Footer";
export default {
  name: "cooperation",
  components: {
    cooperationHeader,
    cooperationJoin,
    cooperationFill,
    cooperationFooter,
  },
  data() {
    return {
      //  判断显示那个组件 0是合作信息 1是表单填写
      joinId: 0,
      topStyle: "",
      actIndex: 6,
      noLine: true,
      imgList: [],
      bottom: {},
      logo: "",
      bottomInfo: {},
      about: {},
      culture: {},
      developList: [],
      teamList: [],
      partner: [],
      titleObj: {},
    };
  },
  methods: {
      _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    Pc_Mobile() {
      if (this._isMobile()) {
        this.$router.push("/m_cooperation");
      } else {
        this.$router.push("/teamwork");
      }
    },
    changeJion(val) {
      this.joinId = val;
    },
      getHeaderImage() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/special",
        { type_two: this.actIndex },
        (res) => {
          if (res.code == 1) {
            this.topStyle =
              "background-image:url('" + res.data.phone_image + "')";
          }
        }
      );
    },
    setLastPage(val) {
      this.joinId = val;
    },
       getPageData() {
      this.$http.post("home/index/m_aboutpag", null, (res) => {
        // console.log(res.data)
        this.bottom = res.data.bottom[0];
        this.logo = this.bottom.logo;
        // this.topStyle =
        //   "background:url('" +
        //   this.$imgUrl +
        //   res.data.header[0].m_gywm.replace(/\\/g, "/") +
        //   "')";
        this.about = res.data.company[0];
        this.culture = res.data.culture[0];
        this.developList = res.data.develop;
        this.teamList = res.data.team;
        this.partner = res.data.partner;
        this.bottomInfo = res.data.contact[0];
      });
    },
  },
  mounted(){
    this.Pc_Mobile();
    this.getPageData();
    this.getHeaderImage();
    this.titleObj = { title: "合作加盟", desc: "携手共创，合作共赢" };

  }
};
</script>


// WEBPACK FOOTER //
// src/views/mobile/cooperation.vue